import { Card } from './ui/card';
import { cn } from '../lib/utils';
import { ArrowDownRight, ArrowUpRight } from 'lucide-react';

export default function KpiCard({ label, value, icon: Icon, trend, trendLabel, accent = 'slate', testId }) {
  const accentMap = {
    blue: 'text-blue-600 bg-blue-50',
    emerald: 'text-emerald-600 bg-emerald-50',
    amber: 'text-amber-600 bg-amber-50',
    red: 'text-red-600 bg-red-50',
    slate: 'text-slate-600 bg-slate-100',
    indigo: 'text-indigo-600 bg-indigo-50',
    violet: 'text-violet-600 bg-violet-50',
  };

  const trendUp = typeof trend === 'number' && trend >= 0;

  return (
    <Card
      className="p-5 border-slate-200 bg-white shadow-sm hover:shadow-md transition-shadow"
      data-testid={testId}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="text-xs uppercase tracking-[0.18em] text-slate-500 font-semibold">{label}</div>
        {Icon && (
          <div className={cn('h-9 w-9 rounded-md flex items-center justify-center', accentMap[accent])}>
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
      <div className="mt-3 font-mono text-3xl font-semibold text-slate-900 leading-none">
        {value}
      </div>
      {(trend !== undefined || trendLabel) && (
        <div className="mt-3 flex items-center gap-1 text-xs">
          {typeof trend === 'number' && (
            <span
              className={cn(
                'inline-flex items-center gap-0.5 font-medium',
                trendUp ? 'text-emerald-600' : 'text-red-600'
              )}
            >
              {trendUp ? <ArrowUpRight className="h-3 w-3" /> : <ArrowDownRight className="h-3 w-3" />}
              {Math.abs(trend)}%
            </span>
          )}
          {trendLabel && <span className="text-slate-500">{trendLabel}</span>}
        </div>
      )}
    </Card>
  );
}
